import get from 'lodash/get';

import { pageContentType } from './getContentType';
import { getDictionaryText } from './getDictionaryText';
import { REGION_KEY } from '../../constants/index';

export const getDetailedPageTags = props => {
  let finalTags = [];
  const contentType = pageContentType(props);
  const dictionaryTagKeys = getDictionaryText(`${contentType}DetailTags`);
  const tagsKeys =
    dictionaryTagKeys &&
    dictionaryTagKeys.length > 0 &&
    dictionaryTagKeys.split(',');
  tagsKeys &&
    tagsKeys.length > 0 &&
    tagsKeys.forEach(item => {
      const [tags, quantity] = item && item.length > 0 && item.split('-');
      finalTags = finalTags.concat(
        getTagsFromKey(
          get(props, `sitecoreContext.route.fields.${tags}`, []),
          quantity, tags
        )
      );
    });
  return finalTags;
};

export const getItenaryItemTags = item => {
  let finalTags = [];
  const tagsKeys = ['activityTags', 'durationTags', 'itineraryTransit']
  tagsKeys.forEach(tag => {
    const tagItem = item[tag];
    if (tagItem && tagItem.length > 0) {
      finalTags = finalTags.concat(tagItem)
    }
  });
  return finalTags;
};

export const handleRegionFieldWithPipe = item => {
  let tag;
  let region;
  tag = item.fields.taxonomyValue.value.split('|');
  if (tag && tag.length > 1) {
    region = tag[1];
    if (!region || region === ' ') {
      region = tag[0];
    }
  } else {
    region = tag;
  }
  region = { text: region, link: item.fields.searchKey.value };
  return region;
}

const getTagsFromKey = (tagList, quantity, routeFieldName) => {
  let tags = [];
  tagList &&
    tagList.length > 0 &&
    tagList.forEach((item, index) => {
      if (
        quantity > index &&
        item &&
        item.fields &&
        item.fields.taxonomyValue &&
        item.fields.taxonomyValue.value &&
        item.fields.searchKey &&
        item.fields.searchKey.value
      ) {
        if ((routeFieldName && routeFieldName.toLowerCase()) === REGION_KEY) {
          tags.push(handleRegionFieldWithPipe(item));
        } else {
          tags.push({ text: item.fields.taxonomyValue.value, link: item.fields.searchKey.value });
        }
      }
    });
  return tags;
};
